/**
 * Khai báo report id
 * created dhan 22.11.2022
 */

//report_id của BIDV
let Report_Id_BIDV = {
  157: '157.BIDV', //chi tiền gửi
  158: '158.BIDV', //Chi tiền gửi mua Vật tư, hàng hóa
  159: '159.BIDV', //Chi tiền gửi mua tài sản cố định
  160: '160.BIDV', // Chi tiền gửi trả nhà cung cấp
  162: '162.BIDV', //Chuyển tiền nội bộ
  163: '163.2.2', //Chi tiền gửi trả lương
};

//report_id của Agribank
let Report_Id_Agribank = {
  157: '30.03', //chi tiền gửi
  158: '158.Agribank', //Chi tiền gửi mua Vật tư, hàng hóa
  159: '30.03_159', //Chi tiền gửi mua tài sản cố định
  160: '30.03_160', // Chi tiền gửi trả nhà cung cấp
  162: '30.03_162', //Chuyển tiền nội bộ
  163: '163.2.1', //Chi tiền gửi trả lương
};

//report_id của Vietcombank
let Report_Id_VCB = {
  157: '157.VCB', //chi tiền gửi
  158: '158.VCB', //Chi tiền gửi mua Vật tư, hàng hóa
  159: '159.VCB', //Chi tiền gửi mua tài sản cố định
  160: '160.VCB', // Chi tiền gửi trả nhà cung cấp
  162: '162.VCB', //Chuyển tiền nội bộ
  163: '163.2.3', //Chi tiền gửi trả lương
};

//report_id của Viettinbank
let Report_Id_Viettinbank = {
  157: '157.UNC_VietinBank', //chi tiền gửi
  158: '158.UNC_VietinBank', //Chi tiền gửi mua Vật tư, hàng hóa
  159: '159.UNC_VietinBank', //Chi tiền gửi mua tài sản cố định
  160: '160.UNC_VietinBank', // Chi tiền gửi trả nhà cung cấp
  162: '162.UNC_VietinBank', //Chuyển tiền nội bộ
  163: '163.UNC_VietinBank', //Chi tiền gửi trả lương
};

//report_id của lệnh chi Viettinbank
let Report_Id_LC_Viettinbank = {
  159: '159.VietinBank', //Chi tiền gửi mua tài sản cố định
};

export default {
  Report_Id_BIDV,
  Report_Id_Agribank,
  Report_Id_VCB,
  Report_Id_Viettinbank,
  Report_Id_LC_Viettinbank,
};
